import { responsive } from '../../utils/helpers'

const styles = {
  cardWrapper: {
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  card: {
    width: responsive('100%', 'calc(50% - 10px)'),
    mb: 3,
    textAlign: 'center',
    lineHeight: 'body',
    fontSize: 1
  },
  link: {
    color: 'black'
  }
}

export default styles
